export default __webpack_public_path__ + "static/media/ELEMENTOS_01.cc63a7cc.png";